import { usePatientBasePath } from './route-utils';
import AppRoutesPatientV1 from './AppRoutesPatientV1';
import AppRoutesPatientV2 from './AppRoutesPatientV2';

export default function AppRoutesPatient() {
  const patientBasePath = usePatientBasePath();
  return patientBasePath === '/v2/s' ? <AppRoutesPatientV2 /> : <AppRoutesPatientV1 />;
}
